import { IeLynxObject } from "../../common/models/eLynxObject";

export const keys = {
    all: ["available-views"],
    lists: () => [
        ...keys.all,
        "list"
    ],
    adminlists: () => [
        ...keys.all,
        "adminlist"
    ],

    list: (
        customerID: number,
        groupID: number,
        eLynxObject?: IeLynxObject,
        offline?: boolean
    ) => [
            ...keys.lists(),
            eLynxObject
                ? {
                    customerID,
                    groupID,
                    objectType: eLynxObject?.objectType,
                    objectID: eLynxObject?.id,
                    offline: offline ?? false
                }
                : "none"
        ],

        adminlist: (
            groupID: number,
        ) => [
                ...keys.adminlists(),
                groupID
            ]
    
};